export default __webpack_public_path__ + "static/media/primaafp4.ee8636b7.jpg";